export enum CondicaoTypes {
  IF = 'if',
  OR = 'or'
}
